<template>
  <div class="container">
    <vue-title title="WOLF | Team" />
    <Header />

    <div class="teams">
      <h3
        :class="{
          light: !isDarkMode,
          dark: isDarkMode
        }"
      >
        Team
      </h3>
      <div class="cards">
        <transition
          appear
          appear-active-class="animate__animated animate__flipInX"
        >
          <a
            class="card card1"
            :class="{ lightCard: !isDarkMode, darkCard: isDarkMode }"
          >
            <img
              class="cardHeader"
              src="@/assets/slack.png"
              :class="{ lightHeader: !isDarkMode, darkHeader: isDarkMode }"
            />
            <h3 :class="{ lightText: isDarkMode, darkText: !isDarkMode }">
              Slack
            </h3>
            <p :class="{ lightText: isDarkMode, darkText: !isDarkMode }">
              Messaging app for all team communication
            </p>
          </a>
        </transition>
        <transition
          appear
          appear-active-class="animate__animated animate__flipInX"
        >
          <a
            class="card card2"
            :class="{ lightCard: !isDarkMode, darkCard: isDarkMode }"
          >
            <img
              class="cardHeader"
              src="@/assets/figma.png"
              :class="{ lightHeader: !isDarkMode, darkHeader: isDarkMode }"
            />
            <h3 :class="{ lightText: isDarkMode, darkText: !isDarkMode }">
              Figma
            </h3>
            <p :class="{ lightText: isDarkMode, darkText: !isDarkMode }">
              Collaborative design tool
            </p>
          </a>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import VueTitle from "@/components/VueTitle";

export default {
  name: "Team",
  components: {
    Header,
    VueTitle
  },
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    }
  }
};
</script>

<style lang="scss" scoped>
.teams {
  margin-left: 25px;
}

h2 {
  @include heading2;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: space-evenly;
}

.card {
  width: 100%;
  max-width: 300px;
  margin: 20px;
  height: 400px;
  border-radius: 10px;
}

.card1 {
  animation-delay: 0.3s;
}
.card2 {
  animation-delay: 0.5s;
}

.lightCard {
  background: $white;
  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.15);

  &:hover {
    box-shadow: 0px 30px 60px rgba(0, 0, 0, 0.35);
  }
}

.darkCard {
  background: $superDarkBackground;
  box-shadow: 0px 20px 40px rgba(255, 255, 255, 0.15);

  &:hover {
    box-shadow: 0px 30px 60px rgba(255, 255, 255, 0.35);
  }
}

.cardHeader {
  width: 100%;
  border-radius: 10px 10px 0 0;
}

.lightHeader {
  background: $lightBackground;
}

.darkHeader {
  background: #283049;
}

h3 {
  @include heading3;
  margin-bottom: 16px;
}

p {
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  margin-left: 16px;
  margin-top: 0;
}
</style>
